// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>7</span>&nbsp;&nbsp;I am for making peace,&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;but when I speak of it, they make ready for war.<br> </p> </div></div>";
// Exports
module.exports = code;